import { FunctionGroup } from "../types/app.enums";
import { Measures } from "../types/app.interfaces";
import { BaseService } from "./BaseService";

export class AttributeService extends BaseService {
  async burgissGetAttribute(investId?: any, attribute?: string, uniqueCellId?: string) {
    const objRequest = this.createPayload(investId, attribute, uniqueCellId);
    return super._pushOperation(
      "BurgissGetAttribute",
      objRequest,
      this.APICONFIG.GETINVESTMENTS,
      FunctionGroup.Getattributes
    );
  }

  createPayload(investId: any[][] = null, attributeName: string = null, alias: string = null) {
    const measuresObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      portfolioID: null,
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: true,
      alternateBaseCurrency: null,
      adjustToMostRecent: false,
      measure: null,
      beginDate: null,
      endDate: null,
      year: null,
      indexID: null,
      premium: null,
      idType: null,
      selectionsetID: null,
      assetID: null,
      weightingMethod: null,
      value: null,
      filter: null,
      attributeName: attributeName,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: 0,
      alias: alias,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: null,
      universe: null,
      weight: null,
      commitment: null,
    };
    return measuresObject;
  }
}
